module.exports = __webpack_public_path__ + "static/media/s4-right-middle.06d3505f.png";